import * as React from 'react';
import {StyleSheet, View} from 'react-native';
import FontAwesome5Pro from '../../icons/FontAwesomeIcon';
import Styles from '../../Styles';
import AVText from '../AVText';
import AVTouchableOpacity from '../AVTouchableOpacity';
import {getDescriber} from '../descriptor/DescriptorType';
import Logger from 'src/logging/Logger';
import Localized from 'src/constants/AppStrings';

type ListItem = {
  accessibilityLabel: string;
  accessibilityHint: string;
  onPressed?: () => void;
  label?: string;
  isShareFile?: boolean;
  testID?: string;
};

type SettingsMenuOptionProps = {
  listItems?: ListItem[];
  switchStatus?: boolean;
  onSwitchToggle?: () => void;
  title?: string;
};

const SettingsMenuOption: React.FC<SettingsMenuOptionProps> = (props) => {
  const {listItems} = props;

  const renderSettingsMenu = (value: ListItem, index: number) => {
    return (
      <View key={index}>
        <AVTouchableOpacity
          style={[styles.optionRow]}
          accessible={true}
          accessibilityRole="button"
          accessibilityState={{disabled: false}}
          accessibilityHint={value?.accessibilityHint}
          aria-disabled={false}
          role="button"
          disabled={false}
          onPress={
            value.isShareFile
              ? () => Logger.Log.shareLogFile()
              : value.onPressed
          }
          testID={value?.testID}
        >
          <View style={[styles.innerRow]}>
            <AVText
              maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm4}
              accessibilityLabel={`${value.accessibilityLabel},`}
              aria-label={`${value.accessibilityLabel}, `}
              style={[
                getDescriber() &&
                  getDescriber().getSettingsMenusStyleDescriptor().optionText,
                typeof value.label === 'string' &&
                  ![Localized.Labels.change_pin].includes(value.label) &&
                  styles.transform,
                styles.flex,
              ]}
            >
              {value.label}
            </AVText>
            <FontAwesome5Pro
              accessibilityLabel="Right arrow icon"
              aria-label="Right arrow icon"
              name="chevron-right"
              color={
                getDescriber() &&
                getDescriber().settingsMenuFontColorDescriptor()
              }
              size={Styles.Fonts.f2}
            />
          </View>
        </AVTouchableOpacity>
        <View
          style={
            index !== listItems?.length - 1
              ? getDescriber() &&
                getDescriber().getSettingsMenusStyleDescriptor().divider
              : null
          }
        />
      </View>
    );
  };

  return (
    <View
      style={[
        getDescriber() &&
          getDescriber().getSettingsMenusStyleDescriptor().enclosureContainer,
        getDescriber() &&
          getDescriber().getSettingsMenusStyleDescriptor().listShadow,
      ]}
    >
      {listItems !== undefined &&
        listItems.map((value: any, index) => {
          return renderSettingsMenu(value, index);
        })}
    </View>
  );
};

const styles = StyleSheet.create({
  divider: {
    backgroundColor: Styles.dividerColor,
    height: 1,
  },
  optionRow: {
    justifyContent: 'center',
    paddingHorizontal: Styles.Spacing.m3,
    minHeight: Styles.MinTouchableArea,
  },
  innerRow: {
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginVertical: Styles.Spacing.m3,
  },
  enclosureContainer: {
    marginHorizontal: Styles.Spacing.m3,
    borderRadius: 10,
    borderColor: Styles.lightGray,
    borderWidth: 1,
    backgroundColor: Styles.white,
  },
  transform: {
    textTransform: 'capitalize',
  },
  flex: {flex: 1},
});
export default SettingsMenuOption;
